import * as React from "react";
import { Menu, MenuButton, MenuItems, MenuPopover, ARROW_STYLE } from "../Menu";
import { useTranslation } from "react-i18next";
import settingsIcon from "./assets/setting.svg";
import helpIcon from "../../assets/helpIcon.svg";
import facebookChat from "../../assets/facebook-messenger.svg";
import chatbotImage from "./assets/chatbot.svg";
import { useAudio } from "../AudioProvider";
import musicOn from "./assets/musicOn.svg";
import musicOff from "./assets/musicOff.svg";
import { useFullScreen } from "../FullScreenProvider";
import fullScreenIcon from "./assets/fullScreen.svg";
import exitFullScreenIcon from "./assets/exitFullScreen.svg";
import { HELP_URL } from "../../config";

export const SettingsSection = ({ mainScreen }: { mainScreen?: boolean }) => {
  const { t } = useTranslation();
  const { muted, toggleMute } = useAudio();
  const [isFullScreen, toggleFullScreen, canFullScreen] = useFullScreen();

  if (!canFullScreen) return null;

  return (
    <Menu>
      <MenuButton className="block">
        <img width={18} height={18} src={settingsIcon} alt="icon" />
      </MenuButton>
      <MenuPopover
        portal={false}
        className="z-20"
        style={{
          width: "max-content",
          transform: mainScreen ? "translateX(-100px)" : "",
        }}
      >
        <div
          style={
            mainScreen
              ? { ...ARROW_STYLE, left: "unset", right: 7 }
              : ARROW_STYLE
          }
        />
        <MenuItems
          className="p-0 rounded overflow-hidden border-none"
          style={{ marginTop: 10 }}
        >
          <div className="rounded shadow-xs" style={{ background: "#1B1F28" }}>
            <div className="py-1">
              <div className="py-2 text-sm leading-5 text-gray-700">
                <a
                  href={HELP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex w-full cursor-pointer items-center gap-2 p-4 hover:bg-blue-700 hover:text-white"
                >
                  <div className="flex-shrink-0">
                    <img src={helpIcon} alt="" />
                  </div>
                  <div className="flex-1 px-1 text-white">{t("faq")}</div>
                </a>
                <a
                  target="_blank"
                  href={process.env.REACT_APP_FACEBOOK_CHAT}
                  className="flex w-full cursor-pointer items-center gap-2 p-4 hover:bg-blue-700 hover:text-white"
                >
                  <div className="flex-shrink-0">
                    <img width={18} src={facebookChat} alt="" />
                  </div>
                  <div className="flex-1 px-1 text-white">Facebook chat</div>
                </a>
                <a
                  target="_blank"
                  href={process.env.REACT_APP_BOT_CHAT}
                  className="flex w-full cursor-pointer items-center gap-2 p-4 hover:bg-blue-700 hover:text-white"
                >
                  <div className="flex-shrink-0">
                    <img src={chatbotImage} alt="" />
                  </div>
                  <div className="flex-1 px-1 text-white">Bot chat</div>
                </a>
                <div
                  className="flex w-full cursor-pointer items-center gap-2 p-4 hover:bg-blue-700 hover:text-white"
                  onClick={toggleMute}
                >
                  <div className="flex-shrink-0">
                    <img src={muted ? musicOff : musicOn} alt="" />
                  </div>
                  <div className="flex-1 px-1 text-white">
                    {t(muted ? "unmute" : "mute")}
                  </div>
                </div>
                <div
                  className="flex w-full cursor-pointer items-center gap-2 p-4 hover:bg-blue-700 hover:text-white"
                  onClick={toggleFullScreen}
                >
                  <div className="flex-shrink-0">
                    <img
                      src={isFullScreen ? exitFullScreenIcon : fullScreenIcon}
                      alt=""
                    />
                  </div>
                  <div className="flex-1 px-1 text-white">
                    {t(isFullScreen ? "exit_fullscreen" : "enter_fullscreen")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </MenuItems>
      </MenuPopover>
    </Menu>
  );
};
